import { put, call, takeEvery } from 'redux-saga/effects';
import { getBundleNetPrice } from 'yoda-interfaces/lib/Pdp/BundleNetPriceApi';
import {
    BUNDLE_NETPRICE_POST_REQUEST,
    BUNDLE_NETPRICE_POST_ERROR,
    BUNDLE_NETPRICE_SUCCESS,
} from '../actionTypes/BundleNetPriceActionTypes';

function* BundleNetPriceSaga(selectedBundleSkus) {
    try {
        const bundleNetPriceDetails = yield call(getBundleNetPrice, {
            payload: selectedBundleSkus.payload,
        });
        yield put({
            type: BUNDLE_NETPRICE_SUCCESS,
            payload: { bundleNetPriceDetails: bundleNetPriceDetails.data },
        });
    } catch (error) {
        yield put({ type: BUNDLE_NETPRICE_POST_ERROR, error });
    }
}

const watchBundleNetPriceSaga = function* watchBundleNetPriceSaga() {
    yield takeEvery(BUNDLE_NETPRICE_POST_REQUEST, BundleNetPriceSaga);
};

watchBundleNetPriceSaga.sagaName = 'bundleNetPriceSaga';

export default watchBundleNetPriceSaga;
